import { Alert as ChakraAlert, AlertProps as ChakraAlertProps } from '@chakra-ui/react';

const Toast = ({ children, ...props }: ChakraAlertProps) => {
  const { status } = props;

  const statusProps =
    status === 'info'
      ? {
          bgColor: 'primaryThemeColour.400',
        }
      : {};

  return (
    <ChakraAlert {...statusProps} {...props}>
      {children}
    </ChakraAlert>
  );
};

export { Toast };
